
export default class EventTypeDTO {

  public category?: string;
  public name?: string;
  public region?: string
  


  // constructor(name: string, region: string, category?: string) {
  //   this.name = name;
  //   this.region = region;
  //   this.category = category;
  // }

}
